import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/api/auth/signin',
		method: 'post',
		data: data
	})
}

AuthService.logout = function (data) {
	return fetch({
		url: 'api/auth/logout',
		method: 'post',
		data: data
	})
}

AuthService.forgotPassword = function (email) {
	return fetch({
		url: `api/auth/forgotPassword?email=${email}`,
		method: 'post',
	})
}


AuthService.loginWithSOS = function () {
	return fetch({
		url: '/oauthSignin',
		method: 'get',
	})
}

export default AuthService;